export default {
  namespaced: true,

  getters: {
    type() {
      return (field) => {
        if (!field) {
          return false;
        }

        return field.type || null;
      };
    },

    some(state, getters, rootState, rootGetters) {
      return (field) => {
        const type = getters.type(field);

        if (!type) {
          return false;
        }

        const config = rootGetters['builder/config'];
        return (
          config.entities.fields.types[type].validations &&
          config.entities.fields.types[type].validations
            .length
        );
      };
    },

    keys(state, getters, rootState, rootGetters) {
      return (field) => {
        if (!getters.some(field)) {
          return [];
        }

        const config = rootGetters['builder/config'];
        const type = getters.type(field);
        return config.entities.fields.types[type]
          .validations;
      };
    },

    validation(state, getters, rootState, rootGetters) {
      return (field, key) => {
        if (!getters.some(field)) {
          throw new Error(`Invalid validation: ${key}`);
        }

        const config = rootGetters['builder/config'];
        const validation =
          config.entities.fields.validations[key];

        if (!validation) {
          throw new Error(`Invalid validation: ${key}`);
        }

        return validation;
      };
    },

    enabled(state, getters, rootState, rootGetters) {
      return (properties, entity, field, key) => {
        if (!getters.some(field)) {
          return false;
        }

        if (!key) {
          return true;
        }

        const validation = getters.validation(field, key);
        return rootGetters['builder/matcher/matches'](
          validation.condition,
          properties,
          entity,
          field,
        );
      };
    },

    required(state, getters) {
      return (field, key) => {
        const validation = getters.validation(field, key);
        return !!validation.required;
      };
    },

    input(state, getters) {
      return (field, key) => {
        const validation = getters.validation(field, key);
        const { input } = validation;

        if (!input) {
          return null;
        }

        return input.toLowerCase();
      };
    },

    htmlField(state, getters) {
      return (field, key) => {
        const input = getters.input(field, key);

        if (!input) {
          return null;
        }

        if (
          [
            'select',
            'entity',
            'field',
            'field_to_display',
          ].includes(input)
        ) {
          return 'select';
        }

        return input;
      };
    },

    help(state, getters) {
      return (field, key) => {
        if (!key) {
          return null;
        }

        const validation = getters.validation(field, key);

        if (!validation.help) {
          return null;
        }

        return validation.help;
      };
    },

    label(state, getters) {
      return (field, key) => {
        const validation = getters.validation(field, key);

        if (!validation.label) {
          return null;
        }

        return validation.label;
      };
    },

    displayableValue(state, getters) {
      return (field, key, value) => {
        const htmlField = getters.htmlField(field, key);

        if (htmlField !== 'select') {
          return value;
        }

        const choices = getters.choices(field, key);
        const choice = choices.find(
          (c) => c.value === value,
        );

        if (!choice) {
          return '';
        }

        return choice.label;
      };
    },

    choices(state, getters) {
      return (field, key) =>
        getters.validationChoices(field, key);
    },

    validationChoices(state, getters) {
      return (field, key) => {
        const validation = getters.validation(field, key);

        const { choices } = validation;

        if (!choices || !Object.keys(choices).length) {
          return [];
        }

        return Object.keys(choices).map((choiceKey) => ({
          value: choiceKey,
          label: choices[choiceKey].label,
        }));
      };
    },
  },
};
